<script setup lang="ts">
import { useCreditSimulatorAnchor } from '~/composables/credit';

defineProps<{ isVisible: boolean }>();

const { scrollToSimulator } = useCreditSimulatorAnchor();
</script>

<template>
	<div class="fixed inset-x-0 bottom-0 z-40 lg:hidden">
		<div v-if="isVisible" class="border-t border-[#262626] bg-black px-6 py-3">
			<a
				href="#simulador"
				class="flex min-h-13 items-center justify-center rounded-xs bg-beige text-[16px] font-medium text-black no-underline"
				@click.prevent="scrollToSimulator"
			>
				Simular agora
			</a>
		</div>
	</div>
</template>
